import React, { useEffect, useState, useMemo } from 'react';
import { Calendar, ChevronLeft, ChevronRight, X } from 'lucide-react';

import '../styles/Home.css';
import '../styles/Events.css';

import Footer from '../components/Footer'

export default function Events() {
    

  return (
    <div className='container'>
        

        <div className='events-header-container'>
            <div className='events-header-title'>CANTO CONFERENCE</div>
            <div className='events-header-text'>
                “Canto conferences, also known as Canto Caribbean, are annual gatherings focused on the Caribbean telecommunications industry. These conferences serve as important networking and knowledge-sharing events for telecom professionals, policymakers, and stakeholders in the Caribbean region.”
            </div>
        </div>

        <div className='events-stats-container'>
            <div className='event-stat-item'>
                <div className='event-stat-number'>4</div>
                <div className='event-stat'>Day Flagship</div>
            </div>
            <div className='event-stat-item'>
                <div className='event-stat-number'>30+</div>
                <div className='event-stat'>Speakers</div>
            </div>
            <div className='event-stat-item'>
                <div className='event-stat-number'>600+</div>
                <div className='event-stat'>Attendees</div>
            </div>
            <div className='event-stat-item'>
                <div className='event-stat-number'>40+</div>
                <div className='event-stat'>Regional Operators</div>
            </div>
        </div>

        <div className='events-presentation-container'>
            <div className='events-presentation-video-container'>
                <video style={{height: '100%', width: '100%'}} controls autoPlay loop onError={(e) => console.log(e)}>
                    <source src={"https://videos.pexels.com/video-files/3250236/3250236-uhd_2560_1440_25fps.mp4"} type='video/mp4'/>
                </video>
            </div>
            <div className='events-presentation-options' style={{marginBottom: '50px'}}>
                <div className='events-presentation-options-header'>Read More</div>
                <div className='events-presentation-options-container'>
                    <div className='events-presentation-options-title'>Canto Conferences 2024: Shaping the Future of ICT in the Caribbean <br/>
                    Join the Region's Premier ICT Conference!</div>

                    <div className='events-presentaion-options-body'>

                        Canto Conferences 2024 is the leading platform for dialogue, collaboration, and innovation in the Caribbean's Information and Communications Technology (ICT) sector. This year’s conference is set to explore the transformative role of technology in driving economic growth, social inclusion, and sustainable development across the region. <br/> <br/>


                        <div style={{fontWeight: 700}}>Expert Panels & Keynotes:</div>

                        Engage with industry leaders and influencers as they share insights on the latest trends in telecom and digital innovation.
                        Keynote speakers from leading tech companies and regional authorities. <br/> <br/>
                        <div style={{fontWeight:700}}>Workshops & Training:</div>

                        Hands-on sessions designed to enhance your skills in areas such as 5G deployment, cybersecurity, and IoT.
                        Certified training programs led by experts to help you stay ahead in the rapidly evolving digital landscape. <br/> <br/>
                        <div style={{fontWeight:700}}>Networking Opportunities:</div>

                        Meet and connect with professionals from across the Caribbean and beyond.
                        Exclusive networking events, including a welcome cocktail party and a gala dinner. <br/> <br/>
                        <div style={{fontWeight:700}}>Startup Showcase:</div>

                        Discover the next big thing in tech as Caribbean startups pitch their innovative solutions.
                        Opportunity to invest in or partner with emerging companies shaping the future of the region. <br/> <br/>
                        <div style={{fontWeight:700}}>Exhibition Hall:</div>

                        Explore the latest products, services, and technologies from leading telecom providers and tech companies.
                        Interactive demos and live product launches. <br/> <br/>
                        <div style={{fontWeight:700}}>Special Focus Sessions:</div>

                        In-depth discussions on critical issues like digital inclusion, smart cities, and sustainable development in the Caribbean.
                        Collaborate with policymakers, industry experts, and NGOs to drive meaningful change. <br/> <br/>
                        <div style={{fontWeight:700}}>Exclusive Networking App:</div>

                        Stay connected before, during, and after the event with our exclusive Canto Connect App.
                        Schedule meetings, join discussion groups, and keep up with event updates on the go.
                    </div>
                </div>
            </div>
        </div>
        
    </div>
  )
}
